import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Constants } from 'src/app/_consts/constants';
import { SharedService } from 'src/app/_shared/shared.service';
import { STableComponent } from '../s-table/s-table.component';

@Component({
  selector: 'app-dashboard-counter',
  template: '',
  imports: []
})
export class DashboardCounterComponent implements OnInit, OnDestroy {

  @ViewChild('table', { static: false }) table: STableComponent;

  public activeTab: number = this.shared.loadActiveTab('dashboard_tab', true, 1)
  public timerUpdateAt: number = Constants.DEFAULT_REFRESH_TIME
  protected timer: any
  public timerCounter: number

  @HostListener('document:click')
  clickout() {
    this.timerCounter = 0
  }

  constructor(protected shared: SharedService) { }

  ngOnInit(): void {
    this.resetTimer()
  }

  ngOnDestroy(): void {
    if (this.timer)
      clearInterval(this.timer)
  }

  resetTimer() {
    if (this.timer)
      clearInterval(this.timer)
    this.timerCounter = 0

    this.timer = setInterval(() => {
      this.timerCounter++
      if (this.timerCounter >= this.timerUpdateAt && this.table) {
        this.table.refresh(true)
        this.resetTimer()
      }
    }, 1000)
  }

  tabChanged() {
    this.shared.saveActiveTab('dashboard_tab', true, this.activeTab)
  }

}
